/* Product card "Sizes in Stock" panel (snippets/lf-card-sizes.liquid, assets/lf-card-sizes.css).
   is-focused mirrors :focus-within so the panel shows for keyboard users exactly as on hover.
   Escape hides the hover panel without moving the mouse (WCAG 1.4.13). */
(function () {
  if (window.lfCardSizes) return;
  window.lfCardSizes = true;

  document.addEventListener('focusin', function (e) {
    var panel = e.target.closest && e.target.closest('.lf-card-sizes');
    if (panel) panel.classList.add('is-focused');
  });

  document.addEventListener('focusout', function (e) {
    var panel = e.target.closest && e.target.closest('.lf-card-sizes');
    if (panel && !panel.contains(e.relatedTarget)) panel.classList.remove('is-focused');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.product-block:hover .lf-card-sizes').forEach(function (p) {
      p.classList.add('is-dismissed');
    });
  });

  document.addEventListener('mouseout', function (e) {
    var card = e.target.closest && e.target.closest('.product-block');
    if (!card || card.contains(e.relatedTarget)) return;
    var p = card.querySelector('.lf-card-sizes.is-dismissed');
    if (p) p.classList.remove('is-dismissed');
  });
})();
